import { observer } from "mobx-react";
import React, { useState } from "react";
import Form from "./Form";
import HideFields from "../../Views/Table/HideFields";
import Filter from "./Filter";
import Group from "./group/Group";
import Sort from "./Sort";
import Color from "./Color";
import RowHeight from "./RowHeight";
import RowDirection from "./RowDirection";
import Options from "./Options";
import { CircularProgress, Button } from "@material-ui/core";
import RefreshData from "./RefreshData";
import { useContext } from "react";
import { ViewStoreContext } from "../ContainerStore";
import styled from "styled-components";
import GFApplicationForm from "./GFApplicationForm/GFApplicationForm";

/** Check if the current client is Genesis Foundation on sheet 16352059 */
function isGFClient(store) {
  const domain = window?.LOGGED_IN_USER?.domain;
  const listId = store?.listConfig?.list?.id;
  return domain === "genesisfoundation" && String(listId) === "16352059";
}

function TableButtons(props) {
  const viewStore = useContext(ViewStoreContext);
  const [showGFForm, setShowGFForm] = useState(false);

  if (!viewStore) {
    return null;
  }

  return (
    <div
      className="textCenter d-flex"
      style={{ marginLeft: 1, alignItems: "center" }}
    >
      <Form />
      {isGFClient(props.store) && (
        <GFApplicationFormButton onClick={() => setShowGFForm(true)}>
          GF Application
        </GFApplicationFormButton>
      )}
      <HideFields viewStore={viewStore} />
      <Filter />
      <Group
        updateGrid={viewStore.redrawGridForGrouping}
        store={viewStore}
        gridApi={viewStore.gridApi}
        themeColor={props.themeColor}
      />
      <Sort store={viewStore} gridApi={viewStore.gridApi} />
      <Color />
      <RowHeight
        rowHeight={props.rowHeight}
        setRowHeight={viewStore.setRowHeight}
      />
      {(viewStore.containerStore?.permissions?.canExport() && props.store?.listConfig?.list?.is_log_sheet == "0") && (
        <Options store={viewStore} gridApi={viewStore.gridApi} />
      )}
      <RefreshData store={viewStore} params={props.params} />
      {(viewStore.containerStore?.permissions?.isAdmin() || props.store?.listConfig?.list?.is_log_sheet == "1") && (
          <RowDirection store={viewStore} />
      )}
      {(process.env.NODE_ENV === "development" ||
        viewStore.loadTypeButtonShown) && (
        <Button
          // variant="contained"
          disabled={viewStore.isGridGrouped}
          onClick={() => {
            viewStore.isLazyLoadEnabled = !viewStore.isLazyLoadEnabled;
            viewStore.addGrid();
          }}
        >
          {viewStore.isLazyLoadEnabled ? "Load All Rows" : "Lazy Load"}
        </Button>
      )}
      {(viewStore.currentApiCallsCount > 0 || viewStore.isTabNameChanging) && (
        <div style={{ color: "green" }}>
          <CircularProgress size={10} color={"inherit"} /> Saving...
        </div>
      )}
       {(viewStore.isCommentsColumnSaving) && (
        <div style={{ color: "green" }}>
          <CircularProgress size={10} color={"inherit"} /> Saving...
        </div>
      )}
      {Object.keys(viewStore.executingEvents).length > 0 && (
        <div style={{ color: "green" }}>
          <CircularProgress size={10} color={"inherit"} /> Executing...
        </div>
      )}
      {viewStore.isColumnDeleting && (
        <div style={{ color: "red" }}>
          <CircularProgress size={10} color={"inherit"} /> deleting column...
        </div>
      )}
      {viewStore.isSheetDeleting && (
        <DeleteSheetDiv>
          <CircularProgress size={10} color={"inherit"} /> deleting sheet...
        </DeleteSheetDiv>
      )}
      {viewStore.isExportingLazyLoadData && (
        <ExportSheetDiv>
          <CircularProgress size={10} color={"inherit"} /> exporting data...
        </ExportSheetDiv>
      )}
      {viewStore.isViewSaving && (
        <ExportSheetDiv>
          <CircularProgress size={10} color={"inherit"} /> saving view...
        </ExportSheetDiv>
      )}
      {showGFForm && isGFClient(props.store) && (
        <GFApplicationForm
          store={props.store}
          onClose={() => setShowGFForm(false)}
        />
      )}
    </div>
  );
}

const DeleteSheetDiv = styled.div`
  color: red;
`;

const ExportSheetDiv = styled.div`
  color: green;
`;

const GFApplicationFormButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border: none;
  border-radius: 5px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  margin: 3px;
  letter-spacing: 0.2px;
  transition: all 0.18s;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35);
  &:hover {
    background: linear-gradient(135deg, #d97706, #b45309);
    box-shadow: 0 3px 10px rgba(245, 158, 11, 0.45);
    transform: translateY(-1px);
  }
`;

export default observer(TableButtons);
